export const buildDelegateService = () => {
    class DelegateService {
        constructor() {
            this.delegates = [];
        }
        register(delegate) {
            this.delegates.push(delegate);
        }
        getDelegate(name) {
            return this.delegates.find((d) => d.name === name);
        }
    }
    return new DelegateService();
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsZWdhdGVGYWN0b3J5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2theWVudGEvc2VydmljZS9kZWxlZ2F0ZUZhY3RvcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsR0FBd0IsRUFBRTtJQUM1RCxNQUFNLGVBQWU7UUFBckI7WUFDVSxjQUFTLEdBQVEsRUFBRSxDQUFDO1FBUzlCLENBQUM7UUFQUSxRQUFRLENBQUMsUUFBVztZQUN6QixJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNoQyxDQUFDO1FBRU0sV0FBVyxDQUFDLElBQVk7WUFDN0IsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsQ0FBQztRQUNyRCxDQUFDO0tBQ0Y7SUFFRCxPQUFPLElBQUksZUFBZSxFQUFFLENBQUM7QUFDL0IsQ0FBQyxDQUFDIn0=